/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { array, object, Schema, string } from '../schema';

export interface PostalAddress {
  country: string;
  addressLine: string[];
  addressType: string;
  streetName: string;
  buildingNumber: string;
  postCode: string;
  townName: string;
  countrySubDivision: string;
}

export const postalAddressSchema: Schema<PostalAddress> = object({
  country: ['Country', string()],
  addressLine: ['AddressLine', array(string())],
  addressType: ['AddressType', string()],
  streetName: ['StreetName', string()],
  buildingNumber: ['BuildingNumber', string()],
  postCode: ['PostCode', string()],
  townName: ['TownName', string()],
  countrySubDivision: ['CountrySubDivision', string()],
});
